import React, { useEffect, useMemo, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Label,
  Button,
  Input,
  FormFeedback,
  Form
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";


const AcademicCycleConfigModal = ({
  modal,
  toggle,
  isEdit,
  academicCycleConfig,
  onSubmit
}) => {

  // 🔹 Configuration de Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: academicCycleConfig?.id || "",
      uuid: academicCycleConfig?.uuid || "",
      name: academicCycleConfig?.name || "",
      level: academicCycleConfig?.level || "",
      max_retakes_allowed: academicCycleConfig?.max_retakes_allowed || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Veuillez saisir le nom"),
      level: Yup.string().required("Veuillez saisir le niveau"),
      max_retakes_allowed: Yup.number().required("Veuillez saisir le nombre maximal de  redoublements autorisés"),
     
    }),
    onSubmit: (values) => {
      // Préparation du payload comme dans CourseUnitModal
      const payload = {
        ...values,
        is_active: Boolean(values.is_active)
      };
      onSubmit(payload);

    
    },
  });

    // 🔹 Sécurité supplémentaire : Reset au changement de mode (Ajout vs Edit)
    useEffect(() => {
      if (modal) {
        if (!isEdit) {
          formik.resetForm();
        }
      }
    }, [modal, isEdit]);
  
  

  return (
    <Modal isOpen={modal} toggle={toggle} backdrop="static" id="staticBackdrop">
      <ModalHeader toggle={toggle} tag="h4">
        {isEdit ? "Modifier - Cycle" : "Ajouter - Cycle"}
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <Row>
            <Col className="col-12">
              
              {/* Nom de l'année */}
              <div className="mb-3">
                <Label>Nom</Label>
                <Input
                  name="name"
                  type="text"
                  placeholder="Nom"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  invalid={formik.touched.name && !!formik.errors.name}
                />
                {formik.touched.name && formik.errors.name && (
                  <FormFeedback type="invalid">{formik.errors.name}</FormFeedback>
                )}
              </div>

              {/* Nom de l'année */}
              <div className="mb-3">
                <Label>Niveau</Label>
                <Input
                  name="level"
                  type="text"
                  placeholder="Niveau"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.level}
                  invalid={formik.touched.level && !!formik.errors.level}
                />
                {formik.touched.level && formik.errors.level && (
                  <FormFeedback type="invalid">{formik.errors.level}</FormFeedback>
                )}
              </div>

              {/* Nom de l'année */}
              <div className="mb-3">
                <Label>Nombre de redoublements autorisés</Label>
                <Input
                  name="max_retakes_allowed"
                  type="number"
                  placeholder="Nombre de redoublements autorisés"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.max_retakes_allowed}
                  invalid={formik.touched.max_retakes_allowed && !!formik.errors.max_retakes_allowed}
                />
                {formik.touched.max_retakes_allowed && formik.errors.max_retakes_allowed && (
                  <FormFeedback type="invalid">{formik.errors.max_retakes_allowed}</FormFeedback>
                )}
              </div>



            

            </Col>
          </Row>

          <Row className="mt-2">
            <Col>
              <div className="text-end">
                <Button type="submit" color="primary" className="save-user">
                  {isEdit ? "Mettre à jour" : "Enregistrer"}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AcademicCycleConfigModal;